import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';

import ForgotPasswordScreen from 'screens/ForgotPasswordScreen';
import HelpScreen from 'screens/HelpScreen';
import LandingScreen from 'screens/LandingScreen';
import LoadingScreen from 'screens/LoadingScreen';
import LoginScreen from 'screens/LoginScreen';
import MaintenanceScreen from 'screens/MaintenanceScreen';
import RegistrationScreen from 'screens/RegistrationScreen';
import ResetPasswordScreen from 'screens/ResetPasswordScreen';
import VerifyEmailScreen from 'screens/VerifyEmailScreen';

const UnauthenticatedApp = () => {
  const [restoreRegistration, setRestoreRegistration] = useState(false);

  // TODO Check local storage for current registration progress
  const registrationStep = undefined;

  useEffect(() => {
    if (registrationStep > 0) {
      setRestoreRegistration(true);
    }
  }, []);

  return (
    <Router>
      {restoreRegistration && (
        <Redirect to={`/register/step-${registrationStep}`} />
      )}
      <Switch>
        <Route exact path="/">
          <Redirect to="/login" />
        </Route>

        {/* Testing route only - remove for production! */}
        <Route exact path="/loading">
          <LoadingScreen
            heading="Loading..."
            description="Please wait while the page loads."
          />
        </Route>

        <LandingScreen exact path="/login" component={LoginScreen} />

        <LandingScreen exact path="/help" component={HelpScreen} />

        <LandingScreen exact path="/forgot" component={ForgotPasswordScreen} />

        <LandingScreen exact path="/verify" component={VerifyEmailScreen} />

        <LandingScreen
          exact
          path="/reset-password"
          component={ResetPasswordScreen}
        />

        <Route exact path="/register">
          <Redirect to="/register/step-1" />
        </Route>

        <Route path="/register/:step?">
          <RegistrationScreen />
        </Route>

        <Route path="/maintenance">
          <MaintenanceScreen />
        </Route>

        <Route path="*">
          <Redirect to="/login" />
        </Route>
      </Switch>
    </Router>
  );
};

export default UnauthenticatedApp;
